/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ home: NonNullable<unknown>, homeScore: NonNullable<unknown>, away: NonNullable<unknown>, awayScore: NonNullable<unknown> }} Push_Match_End_TitleInputs */

const th_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ผลสุดท้าย: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const en_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Final: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ja_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`终场：${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const es_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Final: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const pt_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Final: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const id_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Akhir: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const fr_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fin : ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const tl_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tapos: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const vi_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kết thúc: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ko_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`종료: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const de_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Endstand: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ru_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Итог: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const tr_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bitiş: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const it_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Finale: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const pl_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koniec: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const uk_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Підсумок: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const hi_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समाप्त: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ar_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`النهاية: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ms_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tamat: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const bn_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`শেষ: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_tw2_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`終場：${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_hk2_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`終場：${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ur_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اختتام: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const fa_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`پایان: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const sw_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mwisho: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const nl_push_match_end_title = /** @type {(inputs: Push_Match_End_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einde: ${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

/**
* | output |
* | --- |
* | "Final: {home} {homeScore} – {away} {awayScore}" |
*
* @param {Push_Match_End_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_match_end_title = /** @type {((inputs: Push_Match_End_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Match_End_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_match_end_title(inputs)
	if (locale === "ja") return ja_push_match_end_title(inputs)
	if (locale === "zh") return zh_push_match_end_title(inputs)
	if (locale === "es") return es_push_match_end_title(inputs)
	if (locale === "pt") return pt_push_match_end_title(inputs)
	if (locale === "id") return id_push_match_end_title(inputs)
	if (locale === "fr") return fr_push_match_end_title(inputs)
	if (locale === "tl") return tl_push_match_end_title(inputs)
	if (locale === "vi") return vi_push_match_end_title(inputs)
	if (locale === "ko") return ko_push_match_end_title(inputs)
	if (locale === "de") return de_push_match_end_title(inputs)
	if (locale === "ru") return ru_push_match_end_title(inputs)
	if (locale === "tr") return tr_push_match_end_title(inputs)
	if (locale === "it") return it_push_match_end_title(inputs)
	if (locale === "pl") return pl_push_match_end_title(inputs)
	if (locale === "uk") return uk_push_match_end_title(inputs)
	if (locale === "hi") return hi_push_match_end_title(inputs)
	if (locale === "ar") return ar_push_match_end_title(inputs)
	if (locale === "ms") return ms_push_match_end_title(inputs)
	if (locale === "bn") return bn_push_match_end_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_match_end_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_match_end_title(inputs)
	if (locale === "ur") return ur_push_match_end_title(inputs)
	if (locale === "fa") return fa_push_match_end_title(inputs)
	if (locale === "sw") return sw_push_match_end_title(inputs)
	if (locale === "nl") return nl_push_match_end_title(inputs)
	return en_push_match_end_title(inputs)
});